<template>
  <div class="page-container content-430">
    <!-- :prop-school-id="schoolId" -->
    <div class="header-wrapper-430">
      <SearchBlock
        :prop-school-id="searchData.schoolId"
        :class-time-table-go="true"
        @getSearchValue="handleSearch"
        @handleFormData="handleFormData"
        @handleExportMore="handleExportMore"
      >
      </SearchBlock>
    </div>
    <div class="table-box">
      <Table
        :loading="loadingTimeTable"
        border
        :max-height="tableHeight - 30"
        :columns="timeTableColumn"
        :data="studentTimeTable"
        @on-selection-change="tableSelect"
      >
        <template slot="schoolName" slot-scope="{ row }">
          <div v-if="row.schoolName.length > 26">
            <Poptip trigger="hover" word-wrap width="200">
              <span>{{
                row.schoolName.length > 26
                  ? row.schoolName.slice(0, 26) + '...'
                  : row.schoolName
              }}</span>
              <div slot="content">
                <span>{{ row.schoolName }}</span>
              </div>
            </Poptip>
          </div>
          <div v-else>{{ row.schoolName }}</div>
        </template>
        <template slot="action" slot-scope="{ row }">
          <span
            class="click-btn-430"
            @click="handleShowTimeTable(row)"
          >详情</span>
          <span
            class="click-btn-430"
            @click="handleExportTable(row)"
          >导出</span>
        </template>
      </Table>
      <Page
        :total="pageInfo.total"
        show-sizer
        show-elevator
        show-total
        :current="pageInfo.pageNum"
        class="page-right"
        @on-change="handlePageChange"
        @on-page-size-change="handlePageSize"
      ></Page>
    </div>
    <Modal
      v-model="showSelectExportModal"
      :footer-hide="true"
      :closable="false"
      title="导出Excel"
    >
      <div>
        <div class="ex-select">
          <RadioGroup v-model="isSelect">
            <Radio label="1" style="margin-right: 40px">已勾选的数据</Radio>
            <Radio label="2">当前筛选结果数据</Radio>
          </RadioGroup>
        </div>
        <div class="price-btn-box">
          <Button @click="handleExCancle">取消</Button>
          <Button type="primary" @click="handleExSuccess">确定</Button>
        </div>
      </div>
    </Modal>
    <CourseTypeModal
      ref="CourseTypeModalRef"
      @on-finish="handleSelectSubmit"
    ></CourseTypeModal>
    <div>
      <Modal
        v-model="showExportModal"
        :mask-closable="false"
        title="正在导出"
        @on-cancel="handleCancelExport"
      >
        <Progress :percent="percent" :stroke-width="5"></Progress>
        正在导出表格，请给我一些时间
        <div slot="footer">
          <Button @click="handleCancelExport">取消</Button>
        </div>
      </Modal>
    </div>
    <Drawer v-model="showDrawer" width="90" title="详情">
      <ClassTimeTableGoDetail
        v-if="showDrawer"
        :params-school-id="searchData.schoolId"
        :class-id-str="selectClassId"
        :year-code="searchData.yearCode+''"
        :term-code="searchData.termCode"
      ></ClassTimeTableGoDetail>
    </Drawer>
  </div>
</template>
<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import SearchBlock from '../assets/components/SearchBlock.vue';
import courseSchedulCenter from '@/request/courseSchedulCenter/index.js';
import CourseTypeModal from './assets/components/CourseTypeModal.vue';
import ClassTimeTableGoDetail from './ClassTimeTableGoDetail.vue';
import {
  tableColumnsWidth,
  key,
  slot
} from '@/assets/js/resetTableStyle';
import cateringAdmin from '@/request/cateringAdmin/index.js';
import { timeToStr } from '@/utils/utils.js';
import commonApi from '@/request/common/index.js';
import mixinTableHeight from '@/mixins/mixinTableHeight';
let IntervalId;
export default {
  name: 'CourseSchedulCenterDivideClassTimeTableClassTimeTableGo',
  components: {
    SearchBlock,
    CourseTypeModal,
    ClassTimeTableGoDetail
  },
  filters: {
    formatTime(time) {
      return timeToStr(time);
    }
  },
  mixins: [mixinTableHeight],
  data() {
    return {
      showDrawer: false,
      selectClassId: '',
      tipsIndex: 0,
      tipsArr: [
        '正在导出表格，请耐心等待哦', // 0
        '还在努力导出中，请耐心等待哦' // 1
      ],
      isSelect: '1', // 导出选择
      setData: [], // 勾选数据
      showSelectExportModal: false,
      searchData: {
        schoolId: null,
        branchId: null,
        yearCode: null,
        termCode: null,
        gradeId: null,
        classIds: null
      },
      pageInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      timeTableColumn: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        slot('学校', 'schoolName', tableColumnsWidth.type6),
        // key('校区', 'branchName', tableColumnsWidth.type6),
        key('学期', 'yearTermName', tableColumnsWidth.type5),
        key('年级班级', 'gradeClassName', tableColumnsWidth.type3),
        key('班主任', 'headTeacherName', tableColumnsWidth.type3),
        key('在读人数', 'memCount', tableColumnsWidth.type3),
        key('已报名人数', 'enrolledNum', tableColumnsWidth.type3),
        key('已报名人次', 'enrolledCount', tableColumnsWidth.type3),
        key('未报名人数', 'notEnroll', tableColumnsWidth.type3),
        slot('操作', 'action', tableColumnsWidth.action, { fixed: 'right' })
      ],
      studentTimeTable: [],
      selectData: {},
      schoolName: '', // 学校名称
      selectClassroomId: '', // 选中的课班
      personId: '', // 选中的学生id
      personName: '', // 选中的学生姓名
      portOrg: -1, // 处于哪个端
      schoolId: '',
      tableIdList: [], // 多选id
      showExportModal: false,
      percent: 0, // 进度条,
      yearName: '全部',
      classId: '',
      loadingTimeTable: false,
      downloadUrl: '', // 下载地址
      downloadToken: '',
      userIp: '', // 用户ip
      courseTypeModal: false, // 导出筛选课程分类弹窗
      typeList: [11, 12, 13, 14, 15, 23], // 课程类型-默认
      placeFlag: '1', // 是否包含上课场地
      waitRefundShow: '1'// 1=不显示退款待审核课程
    };
  },
  computed: {
    ...mapState(['userInfo', 'schoolIdForState']),
    ...mapGetters(['routeTitle'])
  },
  created() {
    this.portOrg = Number(localStorage.getItem('portOrg'));
    this.getUserIpAddress();
    this.schoolName = this.userInfo.orgName;
    // this.searchData.schoolId = this.portOrg === 2 ? this.userInfo.orgId : localStorage.getItem('schoolId') ? localStorage.getItem('schoolId') : '';
    this.searchData.schoolId = this.portOrg === 2 ? this.userInfo.orgId : this.schoolIdForState ? this.schoolIdForState : '';
  },
  mounted() {
    this.$eventHub.$on('changeSchool', id => {
      this.searchData.schoolId = id;
      this.pageInfo.pageNum = 1;
      this.getstudentTimeTableList();
    });
  },
  destroyed() {
    this.$eventHub.$off('changeSchool');
  },
  beforeRouteLeave(to, from, next) {
    this.PUSH_CACHEROUTE('CourseSchedulCenterDivideClassTimeTableClassTimeTableGo');
    next();
  },
  activated() {
    this.$eventHub.$on('changeSchool', id => {
      this.searchData.schoolId = id;
      this.pageInfo.pageNum = 1;
      this.getstudentTimeTableList();
    });
    this.getstudentTimeTableList();
  },
  methods: {
    ...mapMutations(['PUSH_CACHEROUTE']),
    // 获取用户IP
    async getUserIpAddress() {
      // this.userIp = getUserIp();
      commonApi.getIpAddr().then(res => {
        this.userIp = res.message;
      });
    },
    // 下载token
    async getDownloadtoken(fileId) {
      const params = {
        fileId: [fileId],
        type: 2
      };
      const res = await cateringAdmin.getDownloadtoken(params);
      if (res.status === 200) {
        this.downloadUrl = res.message.downUrl;
        this.downloadToken = res.message.token;
      }
    },
    handleSearch(data) {
      // this.searchData = data;
      this.tableIdList = [];
      Object.keys(this.searchData).forEach(item => {
        if (item != 'schoolId') {
          this.searchData[item] = data[item] ? data[item] : null;
        }
      });
      // this.searchData.schoolId = this.schoolId;
      this.yearName = data.yearName;
      console.log(data, '拿到的学期名称');
      this.pageInfo.pageNum = 1;
      this.getstudentTimeTableList();
    },
    // 重置
    handleFormData(status) {
      this.resetFields = status;
      this.studentTimeTable = [];
      this.pageInfo.total = 0;
      this.tableIdList = [];
    },

    handlePageChange(page) {
      this.pageInfo.pageNum = page;
      this.getstudentTimeTableList();
    },
    handlePageSize(pageSize) {
      this.pageInfo.pageSize = pageSize;
      this.pageInfo.pageNum === 1 && this.getstudentTimeTableList();
    },
    // 获取班级走向表
    async getstudentTimeTableList() {
      if (!this.searchData.schoolId) {
        return false;
      }
      const params = {
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize
      };
      const paramsTrue = Object.assign(params, this.searchData);
      delete paramsTrue.yearName;
      try {
        this.loadingTimeTable = true;
        const res = await courseSchedulCenter.getClassClassDirection(
          paramsTrue
        );
        if (res.status === 200) {
          this.studentTimeTable = res.message.list;
          this.studentTimeTable.forEach((ele) => {
            ele.yearTermName = this.yearName;
            // ele.termId = this.searchData.termId;
          });
          this.pageInfo.total = Number(res.message.total);
        }
      } catch (err) {
        console.log(err);
      } finally {
        this.loadingTimeTable = false;
      }
    },
    // 点击跳转到班级课表
    handleToClassTable() {
      this.$router.push({
        name: 'courseSchedulCenter_divideClassTimeTable_studentTimeTable_classTimeTable',
        query: {
          classroomId: this.selectClassroomId,
          schoolId: this.searchData.schoolId
        }
      });
    },
    // 展示课表详情
    handleShowTimeTable(row) {
      this.selectClassId = row.classId;
      this.showDrawer = true;

      // const { href } = this.$router.resolve({
      //   path: '/courseSchedulCenter/divideClassTimeTable/ClassTimeTableGoDetail',
      //   query: {
      //     schoolId: this.searchData.schoolId,
      //     classIdStr: row.classId,
      //     yearCode: this.searchData.yearCode,
      //     termCode: this.searchData.termCode
      //   }
      // });
      // window.open(href);
    },
    percentShowFun() {
      this.percent += 20;
      if (this.percent >= 80) {
        clearInterval(IntervalId);
      }
    },
    percentShow() {
      this.percent = 0;
      IntervalId = setInterval(this.percentShowFun, 500);
    },
    // 多选导出
    tableSelect(item) {
      this.tableIdList = item;
    },
    // 获取任务Id
    getTaskId(gradeId, classIds, pageSize) {
      return new Promise(async(resolve, reject) => {
        try {
          const params = {
            ...this.searchData,
            pageNum: this.pageInfo.pageNum,
            pageSize: this.isSelect == 1 ? pageSize : this.pageInfo.total,
            gradeId,
            classIds,
            typeList: this.typeList,
            placeFlag: this.placeFlag != '1',
            addr: this.userIp
          };
          if (this.waitRefundShow === '1') {
            params.waitRefundShow = this.waitRefundShow;
          }
          const res = await courseSchedulCenter.getTaskIdApi(params);
          if (res.status === 200) {
            resolve(res.message);
          } else {
            reject(res.message);
          }
        } catch (err) {
          reject(err);
        }
      });
    },
    // 导出弹窗确定
    async handleExSubmit() {
      // if (!this.classId && this.isSelect == 1 && this.tableIdList.length == 0) {
      //   this.$Message.error("请至少勾选一条记录");
      //   return false;
      // }
      let classIds = [];
      let gradeId = '';
      let pageSize = 0;
      if (!this.classId && this.isSelect == 1 && this.tableIdList.length) {
        this.tableIdList.forEach((ele) => {
          classIds.push(ele.classId);
        });
        gradeId = this.tableIdList[0].gradeId;
        pageSize = this.tableIdList.length;
      } else {
        gradeId = this.searchData.gradeId;
        // this.searchData.classIdStr
        classIds.push(this.classId ? this.classId : this.searchData.classIds);
        classIds = classIds.filter((item) => item);
      }
      gradeId = this.tableIdList.length > 0 ? '' : gradeId;
      const taskId = await this.getTaskId(gradeId, classIds, pageSize);
      try {
        var source = new EventSource(
          `${process.env.VUE_APP_EVENT_SOURCE}/sse/subscribe?id=${taskId}`
        );
        this.percentShow();
        this.showExportModal = true;
        setTimeout(async() => {
          const params = {
            ...this.searchData,
            pageNum: this.pageInfo.pageNum,
            pageSize: this.isSelect == 1 ? pageSize : this.pageInfo.total,
            gradeId,
            classIds,
            typeList: this.typeList,
            placeFlag: this.placeFlag != '1',
            addr: this.userIp
          };
          if (this.waitRefundShow === '1') {
            params.waitRefundShow = this.waitRefundShow;
          }
          const res = await courseSchedulCenter.courseClassDirectionExport(
            params
          );
          this.classId = '';
        }, 3000);
        // 回调
        source.onopen = (event) => {
          console.log(event, '通道打开=====');
        };
        source.onmessage = async(event) => {
          console.log('event.data', event.data);
          this.tipsIndex = Math.round(Math.random());
          const { resultContent, taskStatus } = JSON.parse(event.data);
          //  0 待处理 1 处理中 2处理成功 9处理异常
          if (taskStatus === 2) {
            this.$Message.success('导出成功');
            clearInterval(IntervalId);
            this.percent = 100;
            setTimeout(() => {
              this.showExportModal = false;
              if (!this.classId) {
                this.showSelectExportModal = false;
              }
            }, 500);
            const infoData = JSON.parse(resultContent)[0];
            const { fileId, name } = infoData;
            // await this.getDownloadtoken();
            // downloadReport(this.downloadUrl, { fileId, token: this.downloadToken });
            // return;
            const downloadElement = document.createElement('a');
            await this.getDownloadtoken(fileId);
            const href = `${this.downloadUrl}?fileId=${fileId}&token=${this.downloadToken}`;
            downloadElement.style.display = 'none';
            downloadElement.href = href;
            downloadElement.download = name; // 下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); // 点击下载
            document.body.removeChild(downloadElement); // 下载完成移除元素
            source.close();
          }
          if (taskStatus === 9) {
            clearInterval(IntervalId);
            this.percent = 60;
            setTimeout(() => {
              this.showExportModal = false;
            }, 500);
            this.$Message.error('导出失败');
          }
        };
      } catch (err) {
        clearInterval(IntervalId);
        this.percent = 60;
        setTimeout(() => {
          this.showExportModal = false;
        }, 500);
        this.$Message.error('导出失败');
      }
    },
    // 导出-取消
    handleExCancle() {
      this.showSelectExportModal = false;
    },
    // 多选导出
    handleExportMore() {
      // if (
      //   (!this.classId && !this.searchData.schoolId) ||
      //   !this.searchData.termId
      // ) {
      //   return this.$Message.error('请先选中学校和学期');
      // }
      this.isSelect = '1';
      this.showSelectExportModal = true;
    },
    // 导出默认数据
    getExReset() {
      this.$refs.CourseTypeModalRef.getExReset();
      // this.typeList = [11, 12, 13, 14, 15, 23];
      // this.placeFlag = '1';
    },
    // 单选导出
    handleExportTable(row) {
      this.classId = row.classId;
      // this.termId = row.termId;
      // if (!row.termId) {
      //   return this.$Message.error('请选择一个学校和学期!');
      // }
      this.getExReset();
      this.$refs.CourseTypeModalRef.handleShow();
      // this.courseTypeModal = true;
      // this.handleExSubmit();
    },
    // 批量确定
    handleExSuccess() {
      if (this.isSelect == 1 && this.tableIdList.length == 0) {
        this.$Message.error('请至少勾选一条记录');
        return false;
      }
      this.getExReset();
      this.$refs.CourseTypeModalRef.handleShow();
      // this.courseTypeModal = true;
    },
    // 导出取消
    handleCancelExport() {
      this.showExportModal = false;
    },
    // 导出-选择课程分类-取消
    handleSelectCancle() {
      this.courseTypeModal = false;
    },
    // 导出-选择课程分类-确定
    handleSelectSubmit(info) {
      // const reData = this.$refs.courseTypesRef.getResult();
      this.typeList = info.courseTypesData.typeIds;
      this.placeFlag = info.placeFlag;
      this.waitRefundShow = info.waitRefundShow;
      if (this.typeList.length == 0) {
        this.$Message.error('请至少勾选一个班级课程类型');
        return false;
      }
      this.$refs.CourseTypeModalRef.handleHide();
      this.handleExSubmit();
    }
  }
};
</script>
<style lang="scss" scoped>
.page-container {
  position: relative;
  padding: 20px 20px;
  .table-title-430 {
    position: absolute;
    top: 65px;
    left: 24px;
  }
}

.table-box {
  margin-top: 8px;
}
.time-item-box {
  padding: 8px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  .time-item {
    padding: 8px;
    border-radius: 4px;
    background: rgba(97, 73, 241, 0.1);
    color: #488ffa;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    text-align: left;
    span + span {
      margin-top: 8px;
    }
  }
  .time-item + .time-item {
    margin-top: 24px;
  }
}
.page-right {
  text-align: right;
  margin-top: 16px;
}
.ex-select {
  display: flex;
  text-align: center;
  justify-content: center;
  margin-bottom: 20px;
}
.price-btn-box {
  display: flex;
  justify-content: flex-end;
  button + button {
    margin-left: 24px;
  }
}
.modal-select {
  margin-bottom: 20px;
  .title {
    font-weight: 600;
    margin-bottom: 10px;
  }
  .content {
    padding: 0 10px;
  }
}
</style>
